module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Wind-89488dec2bae1422ddbc3ab24edbd25f.svg";